<unity-page-container contentHeader="Reports" [isLoading]="false">
  <ng-container notifications />
  <ng-container page-return> <unity-action-shared [action]="returnToDashboardAction" /></ng-container>

  <ng-container actions />

  <unity-grid-report-shared />
</unity-page-container>
